import React from "react";
import GlobalStyles from "../../global/GlobalStyles";
import image from "../../assets/images/support.png";
import { FaQuestionCircle } from "react-icons/fa";
import logo from "../../logo.png";
import { SiteName } from "../../global/SiteName";

const SupportPage = () => {
  return (
    <div className="w-full h-screen bg-default2 bg-center bg-cover">
      <div className="w-full h-full bg-black/70 flex flex-col justify-center items-center pt-16">
        <div className="w-5/6 md:w-1/2 lg:w-1/3">
          <div className={GlobalStyles.sectionWrap}>
            <div className="w-full flex flex-col gap-5">
              {/* Header */}
              <div className="flex items-center justify-center gap-2">
                <img src={logo} alt="" className={GlobalStyles.formLogo} />
                <h1 className={GlobalStyles.formHeader}>{SiteName} Support</h1>
              </div>

              {/* Support Image */}
              <div className="flex justify-center">
                <img
                  src={image}
                  alt="Support"
                  className="w-40 h-40 rounded-full bg-primary/20 p-2"
                />
              </div>

              {/* Main Message */}
              <p className={`${GlobalStyles.textSecondary} text-center`}>
                Need help? Click the chat button at the bottom right corner for
                immediate assistance.
              </p>

              {/* FAQ Section */}
              <div className="mt-5">
                <div className="flex items-center gap-2 justify-center mb-3">
                  <FaQuestionCircle className="text-primary" />
                  <h3 className="text-lg font-semibold text-primary">FAQs</h3>
                </div>

                <div className="space-y-3">
                  <div
                    className={`${GlobalStyles.textSecondary} border-b border-primary/20 pb-2`}
                  >
                    <p className="font-medium">How do I track my package?</p>
                    <p className="text-sm">
                      Use your tracking ID on our website's tracking page.
                    </p>
                  </div>
                  <div
                    className={`${GlobalStyles.textSecondary} border-b border-primary/20 pb-2`}
                  >
                    <p className="font-medium">What are your delivery hours?</p>
                    <p className="text-sm">Monday to Saturday, 8AM to 8PM.</p>
                  </div>
                  <div
                    className={`${GlobalStyles.textSecondary} border-b border-primary/20 pb-2`}
                  >
                    <p className="font-medium">
                      Can I change my delivery address?
                    </p>
                    <p className="text-sm">
                      Contact us immediately after placing your order.
                    </p>
                  </div>
                </div>
              </div>

              {/* Support Note */}
              <div
                className={`${GlobalStyles.textSecondary} text-center mt-5 text-sm italic`}
              >
                Our team is available 24/7 to assist you.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
